import * as types from './actionTypes';  
import callShowIntactFileApi from '../api/callShowIntactFileApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doCallShowIntactFile(id) {

  return {
    type: types.DO_CALL_SHOW_INTACT_FILE, 
    id
  };
}

export function doCallShowIntactFileRes(data) { 
  return {
    type: types.DO_CALL_SHOW_INTACT_DOCUMENT_RES, 
    data
  };
}
export function callShowIntactFile(id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      callShowIntactFileApi.doCallShowIntactFile(id).then(data => {
        dispatch(doCallShowIntactFileRes(data));
        dispatch(doCallShowIntactFileRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}